/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearOverwolfCachesResponse
 */
export interface ClearOverwolfCachesResponse {
    /**
     * 
     * @type {number}
     * @memberof ClearOverwolfCachesResponse
     */
    rawDataMapperCachesCleared: number;
    /**
     * 
     * @type {number}
     * @memberof ClearOverwolfCachesResponse
     */
    questConfigCachesCleared: number;
}

/**
 * Check if a given object implements the ClearOverwolfCachesResponse interface.
 */
export function instanceOfClearOverwolfCachesResponse(value: object): value is ClearOverwolfCachesResponse {
    if (!('rawDataMapperCachesCleared' in value) || value['rawDataMapperCachesCleared'] === undefined) return false;
    if (!('questConfigCachesCleared' in value) || value['questConfigCachesCleared'] === undefined) return false;
    return true;
}

export function ClearOverwolfCachesResponseFromJSON(json: any): ClearOverwolfCachesResponse {
    return ClearOverwolfCachesResponseFromJSONTyped(json, false);
}

export function ClearOverwolfCachesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearOverwolfCachesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rawDataMapperCachesCleared': json['rawDataMapperCachesCleared'],
        'questConfigCachesCleared': json['questConfigCachesCleared'],
    };
}

export function ClearOverwolfCachesResponseToJSON(json: any): ClearOverwolfCachesResponse {
    return ClearOverwolfCachesResponseToJSONTyped(json, false);
}

export function ClearOverwolfCachesResponseToJSONTyped(value?: ClearOverwolfCachesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rawDataMapperCachesCleared': value['rawDataMapperCachesCleared'],
        'questConfigCachesCleared': value['questConfigCachesCleared'],
    };
}

